import { z } from 'zod';

import { isType } from '../is-type/is-type';

export const checkIsUrl = isType(z.string().url());
